import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 네이버 뉴스 API 가 내려주는 <b> 태그·HTML 엔티티를 제거해 평문으로 만든다.
// (예: "정신건강 <b>위기</b> &quot;대응&quot;" → '정신건강 위기 "대응"')
export function stripHtml(input: string): string {
  const withoutTags = input.replace(/<[^>]*>/g, "");
  return withoutTags
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .trim();
}
